import { useCategoryStore } from '../../store/categoryStore'

interface Props {
  selectedShortcut: string | null
  onSelect: (id: string | null) => void
  selectedCategory: string
}


export default function ShortcutsBar({ selectedShortcut, onSelect, selectedCategory }: Props) {
  const { categories } = useCategoryStore()
  const shortcuts = categories.filter(c => {
    if (!c.is_shortcut || !c.parent_id) return false
    if (selectedCategory === 'all') return false
    return c.parent_id === selectedCategory
  })

  if (shortcuts.length === 0) return null

  return (
    <div
      className={`flex gap-2 pb-2 lg:pb-3 pt-2 lg:pt-0
        max-w-full overflow-x-auto scrollbar-hide`
      }
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {shortcuts.map(s => (
        <button
          key={s.id}
          onClick={() => onSelect(selectedShortcut === s.id ? null : s.id)}
          className={`shrink-0 px-3 py-1.5 rounded-full text-[13px] font-medium border-none cursor-pointer transition-all
            ${selectedShortcut === s.id
              ? 'bg-green-primary text-white shadow-[0_2px_8px_rgba(45,106,79,0.3)]'
              : 'bg-white text-[#6B6560] hover:bg-[#F2EDE4] shadow-[0_1px_4px_rgba(44,24,16,0.08)]'
            }`}
        >
          {s.name}
        </button>
      ))}
    </div>
  )
}